export default "__VITE_ASSET__f5e4ba9f__"